<template>
  <div id="app">
    <!-- <div class="navHeader">
      <nav-bar></nav-bar>
    </div> -->
    <div class="flex1">
      <router-view />
    </div>
    <!-- <div class="footer">
      <page-footer></page-footer>
    </div> -->

  </div>
</template>

<script>
  import navBar from '@/components/navBar.vue'
  import pageFooter from '@/components/pageFooter.vue'
  export default {
    name: 'App',
    components: {
      navBar,
      pageFooter,
    },
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function() {
          this.isRouterAlive = true
        })
      }
    }
  }
</script>

<style>
  body {
    margin: 0px;
  }

  html,
  body {
    width: 100%;
    height: 100%;
  }

  #app {
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: Microsoft YaHei, 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .flex1 {
    flex: 1;
  }

  .footer {
    height: 60px;
  }

  .iconfont {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }

  ul {
    list-style: none;
    padding: 0px;
    margin: 0;
  }

  ul li {
    list-style: none;
  }

  .navHeader {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
  }
/* 解决 el-table 标题头有偏移 */
  body .el-table th.gutter{
      display: table-cell!important;
  }

  body .el-table colgroup.gutter{
      display: table-cell!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue